(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/extends', 'react', './ModalConsumer'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/extends'), require('react'), require('./ModalConsumer'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.react, global.ModalConsumer);
    global.ModalRoot = mod.exports;
  }
})(this, function (exports, _extends2, _react, _ModalConsumer) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends3 = _interopRequireDefault(_extends2);

  var _react2 = _interopRequireDefault(_react);

  var _ModalConsumer2 = _interopRequireDefault(_ModalConsumer);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /* 
    ModalRoot is where your modals will launch from.
  
    You will likely want to render ModalRoot at the base of your App.
  */

  var ModalRoot = function ModalRoot() {
    return _react2.default.createElement(
      _ModalConsumer2.default,
      null,
      function (_ref) {
        var modalComponent = _ref.modalComponent,
            props = _ref.props,
            hideModal = _ref.hideModal;

        var Modal = modalComponent;
        return Modal && _react2.default.createElement(Modal, (0, _extends3.default)({}, props, { close: hideModal }));
      }
    );
  };

  exports.default = ModalRoot;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/ModalManager/ModalRoot.js
// module id = 1965
// module chunks = 1